var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('v-avatar',[_c('img',{attrs:{"src":"https://vuetifyjs.com/apple-touch-icon-72x72.png","alt":"avatar"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }